export default "__VITE_ASSET__BQaktCqw__"